import React from "react";

import {
  TextField,
  TextFieldProps,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";

const StyledTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-root": {
      "& input": {
        backgroundColor: "#ffffff",
      },
      "& fieldset": {
        borderColor: "#626366",
        borderRadius: "6px",
      },
      "&:hover fieldset": {
        borderColor: "#626366",
      },
    },
  },
})(TextField);

const useStyles = makeStyles(() => ({
  label: {
    fontSize: "15px",
    lineHeight: "24px",
    color: "#000000",
    fontWeight: 400,
    marginBottom: "10px",
  },
}));

export const AcceptanceTextField = (props: TextFieldProps) => {
  const classes = useStyles();
  return (
    <>
      {props.label && (
        <Typography className={classes.label}>{props.label}</Typography>
      )}
      <StyledTextField {...props} variant="outlined" label={undefined} />
    </>
  );
};
